import { SaleStampReportsReducer } from "../reducer/SaleStampReportsReducer";

export const reducer = SaleStampReportsReducer;